import ImageWrapper from "@/components/ImageWrapper";
import { CustomRuleInfo } from "@/utils/types/algolia";
import { Box, Text } from "@dxp-feed/ui";
import Link from "@/components/Link";
import React from "react";

type RedirectTileProps = Readonly<{
  redirectData: CustomRuleInfo;
  onClick: () => void;
}>;
export default function RedirectTile({
  redirectData,
  onClick,
}: RedirectTileProps) {
  return (
    <Link
      href={redirectData?.redirectURL}
      className="card w-full mt-[12px] flex rounded-[12px] overflow-hidden bg-brandSecondary flex-wrap items-center flex-col-reverse lg:flex-row"
      onClick={onClick}
    >
      <Box
        className={
          "flex align-baseline lg:items-center w-full lg:max-w-[464px] lg:w-[39%]"
        }
      >
        <Text
          as="h3"
          className="self-center text-xl lg:text-2xl text-white font-bold py-4 lg:py-0  lg:leading-[46px] leading-[30px]  px-[16px] lg:px-[32px] flex-1 line-clamp-2"
        >
          {redirectData?.cardTitle}
        </Text>
      </Box>
      <Box as="div" className="relative  h-full w-full lg:w-[61%]">
        <ImageWrapper
          className={`!relative !w-[728px] mx-auto !h-[51px] md:!h-[61px] lg:!h-[96px] object-cover`}
          src={redirectData?.cardImage ?? "/searchBanner.jpg"}
          fill
          alt={"searchBanner"}
        />
      </Box>
    </Link>
  );
}
